import { render } from "./ReturnReceipt.vue?vue&type=template&id=979d5626&scoped=true"
import script from "./ReturnReceipt.vue?vue&type=script&lang=js"
export * from "./ReturnReceipt.vue?vue&type=script&lang=js"

import "./ReturnReceipt.vue?vue&type=style&index=0&id=979d5626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979d5626"]])

export default __exports__